/**
 * Mapping pur des codes d'erreur profil U2106 (BL-0244 / BL-0338 / BL-0340).
 * Préfère la description API quand elle est présente.
 */

export const U2106_PROFILE_ERROR_CODES = {
  NO_EMPLOYEE_PROFILE: 'BU210605',
  EMAIL_ALREADY_USED: 'BU210606',
} as const;

export type U2106ProfileErrorCode =
  (typeof U2106_PROFILE_ERROR_CODES)[keyof typeof U2106_PROFILE_ERROR_CODES];

const ERROR_I18N_KEYS: Record<U2106ProfileErrorCode, string> = {
  BU210605: 'myProfile.errors.noEmployee',
  BU210606: 'myProfile.emailAlreadyUsed',
};

export type U2106ProfileApiErrorFragment = {
  errorCode?: string;
  description?: string;
};

type TranslateFn = (key: string, options?: Record<string, unknown>) => string;

/** Résout le message à afficher : description API en priorité, sinon clé i18n locale. */
export function u2106ResolveProfileErrorMessage(
  err: U2106ProfileApiErrorFragment,
  t: TranslateFn,
  nameSpace: string,
): string {
  const description = err.description?.trim();
  if (description) {
    return description;
  }

  const code = err.errorCode as U2106ProfileErrorCode | undefined;
  if (code && code in ERROR_I18N_KEYS) {
    return t(ERROR_I18N_KEYS[code], { ns: nameSpace });
  }

  return t('myProfile.errors.generic', { ns: nameSpace, errorCode: err.errorCode ?? '' });
}

/** True si le code est un code métier profil U2106 connu. */
export function u2106IsProfileErrorCode(code: string | undefined): code is U2106ProfileErrorCode {
  return !!code && code in ERROR_I18N_KEYS;
}
